module.exports = __webpack_public_path__ + "static/media/img.201564a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/img.png
// module id = 1486
// module chunks = 0